import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetDataEmail, GetDataUserGroup, SetDataMenuData, SetDataActiveUserGroup } from '../utils/data-storage';
import MapGroupScreenService from '../../services/mapGroupScreenService';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

const DdlProfile = ({useRoleInPage, codeInPage}) => {
    const navigate = useNavigate();
    const [ddlRole, setDdlRole]     = useState(false);
    const [ddlAvatar, setDdlAvatar] = useState(false);
    const [changeTo, setChangeTo]   = useState(1);

    useEffect(() => {
        if (useRoleInPage === "ADMIN" || useRoleInPage === "REPORTER") {
            setChangeTo(1); // สลับไป User (group 1)
        } else {
            setChangeTo(2); // สลับไป Admin (group 2)
        }
    }, [useRoleInPage]);

    const OnClickGoToProfile = () => {
        const params = GetDataEmail() + "::" + codeInPage;
        navigate("/profile/" + btoa(params), { replace: true });
    };

    const OnClickLogout = () => {
        navigate("/logout", { replace: true });
    };

    const OnClickSwitchRole = () => {
        SwitchRoleAndLoadMenu(changeTo, useRoleInPage);
    };

    const SwitchRoleAndLoadMenu = async (idUserGroup, pageInRoleNow) => {
        const respScreen = await MapGroupScreenService.GetMapGroupScreens({ id_user_group: idUserGroup, status: 1 });
        SetDataMenuData(respScreen.data.result || []);
        // ── FIX: ใช้ "active user group" (คนละตัวกับ "ugd" ตัวจริง) เก็บว่ากำลังสวมบทบาทดูเป็น group ไหนอยู่ ──
        // ── ห้ามเขียนทับ "ugd" (ค่าจริงตอน login) เพราะ "ugd" ใช้เช็คว่า admin ตัวจริงหรือเปล่า (ดูเงื่อนไข userGroup === "2" ด้านล่าง) ──
        // ── ถ้าเขียนทับ ugd ตอน admin สลับไปดูเป็น user, admin จะกลายเป็น "user จริง" ไปเลย แล้วสลับกลับมา Admin ไม่ได้อีก ──
        // ── (เงื่อนไข useRoleInPage === "USER" && userGroup === "2" จะเป็น false ทันที เพราะ ugd ถูกเปลี่ยนเป็น "1" ไปแล้ว) ──
        SetDataActiveUserGroup(idUserGroup);
        if (pageInRoleNow === "USER") {
            navigate("/admin/requests", { replace: true });
        } else {
            navigate("/user/requests", { replace: true });
        }
    };

    const userGroup = GetDataUserGroup();

    const GetInitialsFromEmail = (email) => {
        if (!email) return '';
        const namePart = email.split('@')[0];
        const segments = namePart.split(/[.\-_]/).filter(Boolean);
        if (segments.length >= 2) {
            return (segments[0][0] + segments[1][0]).toUpperCase();
        }
        return namePart.substring(0, 2).toUpperCase();
    };

    const avatarInitials = GetInitialsFromEmail(GetDataEmail());

    return (
        <React.Fragment>
            {/* หน้า USER + group 2 (Admin) — มี dropdown สลับไป Admin */}
            {useRoleInPage === "USER" && userGroup === "2" && (
                <Dropdown isOpen={ddlRole} toggle={() => setDdlRole(!ddlRole)}>
                    <DropdownToggle className="topbar-admin-btn">
                        User
                        <i className="ri-arrow-down-s-line"></i>
                    </DropdownToggle>
                    <DropdownMenu className="ddl-menu-profile">
                        <DropdownItem className="ddl-item-profile" onClick={OnClickSwitchRole}>
                            Admin
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            )}

            {/* หน้า USER + group อื่น — แสดง label เฉยๆ */}
            {useRoleInPage === "USER" && userGroup !== "2" && (
                <div className="topbar-role-badge">
                    {userGroup === "4" ? "Reporter" : "User"}
                </div>
            )}

            {/* Reporter — แสดง label เฉยๆ */}
            {useRoleInPage === "ADMIN" && userGroup === "4" && (
                <div className="topbar-role-badge">
                    Reporter
                </div>
            )}

            {/* Admin — มี dropdown สลับไป User */}
            {useRoleInPage === "ADMIN" && userGroup !== "1" && userGroup !== "4" && (
                <Dropdown isOpen={ddlRole} toggle={() => setDdlRole(!ddlRole)}>
                    <DropdownToggle className="topbar-admin-btn">
                        Admin
                        <i className="ri-arrow-down-s-line"></i>
                    </DropdownToggle>
                    <DropdownMenu className="ddl-menu-profile">
                        <DropdownItem className="ddl-item-profile" onClick={OnClickSwitchRole}>
                            User
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            )}

            {/* Dropdown Avatar */}
            <Dropdown isOpen={ddlAvatar} toggle={() => setDdlAvatar(!ddlAvatar)}>
                <DropdownToggle tag="div" className="topbar-avatar">
                    <span className="topbar-avatar-initials">{avatarInitials}</span>
                </DropdownToggle>
                <DropdownMenu className="ddl-menu-profile">
                    <DropdownItem className="ddl-item-profile" onClick={OnClickGoToProfile}>
                        Profile
                    </DropdownItem>
                    <DropdownItem className="ddl-item-profile" onClick={OnClickLogout}>
                        Logout
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default DdlProfile;